<template>
  <transition name="slide-fade">
    <div class="panel">
      <form @submit.prevent="submit">
        <div class="field-container">
          <div class="email-wrapper mr4 w-50">
            <label for="email" class="db mb2 f6 ttu fw7">Email</label>
            <input
              type="email"
              name="email"
              id="email"
              required
              class="w-100 pa2"
              autofocus
              v-model="email"
            />
          </div>

          <div class="password-wrapper w-50">
            <label for="email" class="db mb2 f6 ttu fw7">Password</label>
            <input
              type="password"
              name="password"
              id="password"
              required
              class="w-100 pa2"
              v-model="password"
            />
          </div>
        </div>

        <input
          type="submit"
          value="Login »"
          class="w-50 dib-ns pa2 michigan-blue bg-michigan-maize no-underline b ba bw1 b--michigan-maize transition ttu db pointer"
        />
      </form>
    </div>
  </transition>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import "../../node_modules/firebaseui/dist/firebaseui.css";
import { mapMutations } from "vuex";

export default {
  name: "auth",
  data() {
    return {
      email: "",
      password: "",
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$router.push("/");
      }
    });
  },
  methods: {
    ...mapMutations([
      "changePageTitle",
      "changePageIntroText",
      "modifyLoggedIn",
      "setAnalytics",
    ]),
    submit() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then((response) => {
          firebase.analytics().setUserId(response.user.id);
          
          this.modifyLoggedIn(true);
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  mounted() {
    // Set logged in to false.
    this.modifyLoggedIn(false);

    // Set the page title.
    this.changePageTitle("Login");

    // Set page text.
    this.changePageIntroText();
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
}

.panel {
  padding: 2rem;
}

form label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 700;
}

input {
  width: 100%;
}

input[type="submit"] {
  background-color: var(--michigan-maize);
  border: 2px solid var(--michigan-maize);
  cursor: pointer;
  padding: 0.5rem;
}

input[type="submit"] {
  border-radius: 0;
  text-transform: uppercase;
  width: 25%;
}

.email-wrapper {
  margin-right: 1rem;
  width: 25%;
}

.password-wrapper {
  width: 25%;
}

.field-container {
  display: flex;
  margin-bottom: 1rem;
}
</style>
